var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoUnfold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.22501 8.32502C8.04168 8.14169 7.95001 7.90002 7.95001 7.60002C7.95001 7.30002 8.04168 7.05836 8.22501 6.87502L11.3 3.80002C11.4 3.70002 11.5083 3.62902 11.625 3.58702C11.7417 3.54569 11.8667 3.52502 12 3.52502C12.1333 3.52502 12.2627 3.54569 12.388 3.58702C12.5127 3.62902 12.6167 3.70002 12.7 3.80002L15.8 6.90002C15.9833 7.08336 16.0707 7.32069 16.062 7.61202C16.054 7.90402 15.9583 8.14169 15.775 8.32502C15.5917 8.50836 15.35 8.60002 15.05 8.60002C14.75 8.60002 14.5083 8.50836 14.325 8.32502L12 6.00002L9.65001 8.35002C9.46668 8.53336 9.22935 8.62102 8.93801 8.61302C8.64601 8.60436 8.40835 8.50836 8.22501 8.32502ZM12 20.575C11.8667 20.575 11.7417 20.55 11.625 20.5C11.5083 20.45 11.4 20.3834 11.3 20.3L8.22501 17.225C8.04168 17.0417 7.95001 16.8 7.95001 16.5C7.95001 16.2 8.04168 15.9584 8.22501 15.775C8.40835 15.5917 8.65001 15.5 8.95001 15.5C9.25001 15.5 9.49168 15.5917 9.67501 15.775L12 18.1L14.35 15.75C14.5333 15.5667 14.7707 15.4794 15.062 15.488C15.354 15.496 15.5917 15.5917 15.775 15.775C15.9583 15.9584 16.05 16.2 16.05 16.5C16.05 16.8 15.9583 17.0417 15.775 17.225L12.7 20.3C12.6167 20.3834 12.5127 20.45 12.388 20.5C12.2627 20.55 12.1333 20.575 12 20.575Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoUnfold);
export default __webpack_public_path__ + "static/media/ico-unfold.c0fba7d289f49eb436b9a79cd68c9180.svg";
export { ForwardRef as ReactComponent };